import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";
import { PonderTasksClient } from "@apiserver-rest/ponder-tasks-client";
import { GetTaskHistoryResponse, TaskDescription, TaskRunSummary, TaskStatusType } from "@apiserver-rest/ponder-tasks-client-base";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { FormatDatePipe } from "@ponder-shared/pipes/format-date.pipe";
import { ColorDictionary } from "@ponder-shared/utils/colors";
import { take } from "rxjs";

@Component({
    selector: "task-history-table",
    imports: [NgClass, LoadingComponent, FormatDatePipe],
    templateUrl: "./task-history-table.component.html"
})
export class TaskHistoryTableComponent {
    @Input({ required: true }) public task!: TaskDescription;
    
    public isLoading: boolean = false;
    public loadingSuccess: boolean = false;

    private readonly pageCount: number = 25;
    public pageStart: number = 0;
    public pageEnd: number = 0;
    public totalRuns: number = 0;
    public taskRuns?: TaskRunSummary[];
    
    public constructor(private ponderTasksClient: PonderTasksClient, private events: EventBroker) {

    }

    public ngOnInit(): void {
        this.fetchData(0);
    }

    public ngOnChanges(): void {
        this.fetchData(0);
    }

    private fetchData(pageStartIndex: number): void {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;
        this.loadingSuccess = false;
        this.pageStart = Math.max(0, pageStartIndex);

        this.ponderTasksClient
            .tasksHistory(this.task.taskName, this.pageStart, this.pageCount)
            .pipe(take(1))
            .subscribe({
                next: (response: GetTaskHistoryResponse) => {
                    if (response) {
                        this.taskRuns = response.runs;
                        this.totalRuns = response.total ?? 0;
                        this.pageEnd = this.pageStart + (this.taskRuns ? this.taskRuns.length : 0);
                        this.loadingSuccess = true;
                    }
                }
            })
            .add(() => { this.isLoading = false; });
    }

    public getStatusColor(taskRun: TaskRunSummary): string {
        switch (taskRun.status) {
            case TaskStatusType.Success:
                return ColorDictionary.StatusGreen;

            case TaskStatusType.Failure:
                return ColorDictionary.StatusRed;

            case TaskStatusType.Cancelled:
                return ColorDictionary.StatusOrange;

            case TaskStatusType.Pending:
                return ColorDictionary.StatusGray;

            case TaskStatusType.Running:
                return ColorDictionary.StatusBlue;
        }
    }

    public onNextClicked(): void {
        this.fetchData(this.pageEnd);
    }

    public onPrevClicked(): void {
        this.fetchData(this.pageStart - this.pageCount - 1);
    }

    public onTaskRunClicked(taskRun: TaskRunSummary): void {
        this.events.admin.viewTaskEvent.emit(taskRun.id);
    }
}